import React from 'react';
import { StyledWrapperStepContent } from './index.style';
import ActionsHeader from '../VoiceSampleUploader/ActionsHeader';

const WrapperStepContent = ({
  children,
  onSetStep,
  showReloadButton = false,
  onReload,
  onResetMetadataAudio,
  disabledButtonRefetch,
  hideHeader = false,
  prevStep,
}) => (
  <StyledWrapperStepContent>
    {!hideHeader && (
      <ActionsHeader
        onSetStep={onSetStep}
        showReloadButton={showReloadButton}
        onReload={onReload}
        onResetMetadataAudio={onResetMetadataAudio}
        disabledButtonRefetch={disabledButtonRefetch}
        prevStep={prevStep}
      />
    )}
    {children}
  </StyledWrapperStepContent>
);

export default WrapperStepContent;
